
document.addEventListener('DOMContentLoaded', function () {
  let currentStep = 1;
  const totalSteps = 7;

  function showStep(step) {
    document.querySelectorAll('.wizard-step').forEach(el => el.style.display = 'none');
    const stepEl = document.getElementById('step' + step);
    if (stepEl) stepEl.style.display = 'block';

    // Update progress indicators if present
    document.querySelectorAll('.progress-step').forEach(el => el.classList.remove('active', 'passed'));
    for (let i = 1; i <= totalSteps; i++) {
      const el = document.getElementById('progress-step' + i);
      if (!el) continue;
      if (i < step) el.classList.add('passed');
      if (i === step) el.classList.add('active');
    }

    currentStep = step;
  }

  function nextStep() {
    if (currentStep < totalSteps) {
      showStep(currentStep + 1);
    }
  }

  function prevStep() {
    if (currentStep > 1) {
      showStep(currentStep - 1);
    }
  }

  // Handle clicks on answers
  document.querySelectorAll('.answers-list li').forEach(li => {
    li.addEventListener('click', function () {
      const siblings = li.parentElement.querySelectorAll('li');
      siblings.forEach(sib => sib.classList.remove('active'));
      li.classList.add('active');

      const value = li.querySelector('span') ? li.querySelector('span').textContent : li.textContent;
      const hiddenInput = li.closest('.wizard-step').querySelector('input[type="hidden"]');
      if (hiddenInput) hiddenInput.value = value;

      setTimeout(nextStep, 300); // advance to next step
    });
  });

  // Next/previous buttons
  document.querySelectorAll('[data-action="next"]').forEach(btn => {
    btn.addEventListener('click', nextStep);
  });

  document.querySelectorAll('[data-action="prev"]').forEach(btn => {
    btn.addEventListener('click', prevStep);
  });

  // Optional: Enter key handling in text inputs
  document.querySelectorAll('.wizard-step input[type="text"]').forEach(input => {
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && input.value.trim() !== '') {
        nextStep();
      }
    });
  });

  // Init first step
  showStep(currentStep);
});

